import React, { useEffect, useState } from 'react';

export default function Loader() {
   const [show, setShow] = useState(false);
   const [fadeOut, setFadeOut] = useState(false);

   useEffect(() => {
      // 1. Mostrar después de 200ms (evita parpadeos en Loadable al navegar)
      const showTimeout = setTimeout(() => {
         setShow(true);
      }, 200);

      // 2. Iniciar animación de desvanecimiento a los 2500ms
      const fadeOutTimeout = setTimeout(() => {
         setFadeOut(true);
      }, 2500);

      // 3. Ocultar completamente del DOM después de 3000ms
      const hideTimeout = setTimeout(() => {
         setShow(false);
      }, 3000);

      return () => {
         clearTimeout(showTimeout);
         clearTimeout(fadeOutTimeout);
         clearTimeout(hideTimeout);
      };
   }, []);

   return (
      <>
         {show && (
            <div 
               className="loader-wrapper position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
               style={{ 
                  zIndex: 9999, 
                  backgroundColor: 'rgba(255, 255, 255, 0.6)', 
                  backdropFilter: 'blur(4px)',
                  opacity: fadeOut ? 0 : 1,
                  transition: 'opacity 0.5s ease-out'
               }}
            >
               <div className="loader">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
               </div>
            </div>
         )}
      </>
   );
}
